//Below function copied from: https://gist.github.com/stewartknapman/8d8733ea58d2314c373e94114472d44c
//Function used to format the price with the shop's currency configuraion.
function formatMoney(cents, format) {
  if (typeof cents == "string") {
    cents = cents.replace(".", "");
  }
  var value = "";
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || this.money_format;

  function defaultOption(opt, def) {
    return typeof opt == "undefined" ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ",");
    decimal = defaultOption(decimal, ".");

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split("."),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
      cents = parts[1] ? decimal + parts[1] : "";

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
  }

  return formatString.replace(placeholderRegex, value);
}

document.addEventListener("DOMContentLoaded", function () {
  //Function for expansion of info-items
  const allInfoItems = document.querySelectorAll(".info-item");
  allInfoItems.forEach((infoItem) => {
    infoItem.addEventListener("click", function () {
      const infoText = infoItem.querySelector(".info-text");
      const scrollHeight = infoText.scrollHeight;
      allInfoItems.forEach((item) => {
        //remove expanded class from other info-items
        if (item !== this) {
          item.classList.remove("expanded-info-item");
        }
      });
      //toggle expanded class in clicked info-item
      this.classList.toggle("expanded-info-item");
    });
  });

  //Event: Managing scroll of page for viewport size greater than 1040px
  {
    const productImagesContainer = document.querySelector(".product-images");
    const main = document.querySelector("main");

    function isImagesFullyScrolled() {
      return (
        productImagesContainer.scrollTop >=
        productImagesContainer.scrollHeight -
          productImagesContainer.clientHeight
      );
    }
    function isPageAtTop() {
      return (window.pageYOffset || document.documentElement.scrollTop) === 0;
    }
    main.addEventListener(
      "wheel",
      function (e) {
        // Ignore till viewport size <= 1040px
        if (window.innerWidth <= 1040) return;

        if (!isImagesFullyScrolled() && isPageAtTop()) {
          e.preventDefault();
          productImagesContainer.scrollTop += e.deltaY;
        }
        if (isImagesFullyScrolled() && isPageAtTop()) {
          if (e.deltaY < 0) e.preventDefault();
          productImagesContainer.scrollTop += e.deltaY;
        }
      },
      { passive: false }
    );
  }

  //Block for selecting variant, updating quantity & price, adding product to cart
  {
    const form = document.querySelector("#product-form");
    if (!form) return;
    const productId = form.getAttribute("data-product-id");
    const jsonElement = document.getElementById(`ProductJson-${productId}`);
    console.log(jsonElement);
    if (!jsonElement) {
      console.error("Product JSON element not found for ID:", productId);
      return;
    }
    const productVariants = JSON.parse(jsonElement.innerHTML);
    console.log(productVariants);
    const addToCartBtn = form.querySelector(".add-to-cart");
    const qtyInput = form.querySelector(".item-quantity");
    const priceDisplay = form.querySelector("[data-product-price]");
    const totalDisplay = form.querySelector("[data-total-price]");
    const variantIdInput = form.querySelector("#variant-id-input");

    //Money format
    const moneyFormat = document
      .querySelector(".cart")
      .getAttribute("data-money-format");

    function updateProductState() {
      //Collecting the selected option values
      let selectedOptions = [];
      form
        .querySelectorAll(".single-option-selector:checked")
        .forEach((radio) => {
          selectedOptions.push(radio.value);
        });

      //Finding the variant matching the selected options
      const matchedVariant = productVariants.find((variant) => {
        return selectedOptions.every((option) =>
          variant.options.includes(option)
        );
      });
      console.log(matchedVariant);

      if (matchedVariant) {
        variantIdInput.value = matchedVariant.id;

        //Updating price calculation
        const currentQty = parseInt(qtyInput.value) || 1;
        const unitPrice = matchedVariant.price;
        const totalPrice = currentQty * unitPrice;
        console.log(unitPrice);
        //update HTML
        priceDisplay.innerHTML = formatMoney(unitPrice, moneyFormat);
        totalDisplay.textContent = ` (${formatMoney(totalPrice, moneyFormat)})`;

        if (matchedVariant.available) {
          addToCartBtn.disabled = false;
          addToCartBtn.querySelector("span:first-child").innerText =
            "Add to Cart";
        } else {
          addToCartBtn.disabled = true;
          addToCartBtn.querySelector("span:first-child").innerText = "Sold Out";
          addToCartBtn.querySelector("span:nth-child(2)").innerText = "";
        }
      }
    }

    //Event: Variant Radio changes
    form.querySelectorAll(".single-option-selector").forEach((input) => {
      input.addEventListener("change", updateProductState);
    });

    //Event: Quantity changes
    form.querySelectorAll(".quantity-button").forEach((button) => {
      button.addEventListener("click", () => {
        let value = parseInt(qtyInput.value) || 1;
        if (button.classList.contains("plus")) {
          value++;
        } else if (value > 1) {
          value--;
        }
        qtyInput.value = value;
        updateProductState();
      });
    });

    //Event: Add to Cart (Async)
    addToCartBtn.addEventListener("click", async (e) => {
      e.preventDefault();

      const variantId = variantIdInput.value;
      const quantity = parseInt(qtyInput.value) || 1;

      try {
        const cartRes = await axios.post("/cart/add.js", {
          id: variantId,
          quantity: quantity,
          sections: "cart-drawer",
        });
        // Update cart drawer UI
        const newSectionHTML = cartRes.data.sections["cart-drawer"];
        const currentContent = document.querySelector(".cart-drawer-content");

        if (newSectionHTML && currentContent) {
          const parser = new DOMParser();
          const newDoc = parser.parseFromString(newSectionHTML, "text/html");
          currentContent.innerHTML = newDoc.querySelector(
            ".cart-drawer-content"
          ).innerHTML;
        }

        if (window.initCartDrawer) window.initCartDrawer();
        window.refreshHeaderCartCount();
      } catch (err) {
        console.error("Add to cart failed:", err.response?.data || err);
        alert("Selection unavailable. Please try another option.");
      }
    });
  }

  // //Asynchronous add to cart implementation

  // const addToCart = document.querySelector(".add-to-cart");

  // addToCart.addEventListener("click", async (e) => {
  //   e.preventDefault();
  //   e.stopPropagation();

  //   const inputQuantity =
  //     addToCart.parentElement.querySelector(".item-quantity");
  //   const value = Number(inputQuantity.value);

  //   console.log("Adding quantity:", value);
  //   const pathParts = window.location.pathname.split("/").filter(Boolean);
  //   const handle = pathParts[1];
  //   const productUrl = `/products/${handle}.js`;

  //   try {
  //     const res = await axios.get(productUrl);
  //     const product = res.data;

  //     // Use first available variant (or selected variant logic)
  //     const variantId = product.variants[0].id; // Number or string works [web:29]
  //     console.log("Variant ID:", variantId, "Product:", product);

  //     const cartRes = await axios.post("/cart/add.js", {
  //       id: variantId,
  //       quantity: value,
  //       sections: "cart-drawer",
  //     });

  //     console.log("Added to cart:", cartRes.data);

  //     const newSectionHTML = cartRes.data.sections["cart-drawer"];
  //     const parser = new DOMParser();
  //     const newDoc = parser.parseFromString(newSectionHTML, "text/html");
  //     const newContent = newDoc.querySelector(".cart-drawer-content");
  //     const currentContent = document.querySelector(".cart-drawer-content");

  //     if (newContent && currentContent) {
  //       currentContent.innerHTML = newContent.innerHTML;
  //     }

  //     if (window.initCartDrawer) {
  //       window.initCartDrawer();
  //     }
  //   } catch (err) {
  //     console.error("Add to cart failed:", err.response?.data || err);
  //   }
  // });

  // //Function for quantity component logic
  // document.querySelectorAll(".quantity-button").forEach((button) => {
  //   button.addEventListener("click", () => {
  //     const input = button.parentElement.querySelector(".item-quantity");
  //     const value = Number(input.value);
  //     const isPlus = button.classList.contains("plus");

  //     const pathParts = window.location.pathname.split("/").filter(Boolean);
  //     const handle = pathParts[1];
  //     const productUrl = `/products/${handle}.js`;
  //     let productPrice;

  //     axios.get(productUrl).then((res) => {
  //       const product = res.data;

  //       if (product.compare_at_price) {
  //         productPrice = product.compare_at_price;
  //       } else {
  //         productPrice = product.price;
  //       }

  //       const moneyFormat = document
  //         .querySelector(".cart")
  //         .getAttribute("data-money-format");

  //       if (isPlus) {
  //         input.value = value + 1;
  //         let totalPrice = productPrice * Number(input.value);
  //         addToCart.querySelector(".total-price").textContent = `(${formatMoney(
  //           totalPrice,
  //           moneyFormat
  //         )})`;
  //       } else if (value > 1) {
  //         input.value = value - 1;
  //         let totalPrice = productPrice * Number(input.value);
  //         addToCart.querySelector(".total-price").textContent = `(${formatMoney(
  //           totalPrice,
  //           moneyFormat
  //         )})`;
  //       }
  //     });
  //   });
  // });
});
